import Box from '@mui/material/Box';
import React from 'react';
import classroomImg from '../assets/ksim-classroom-site.png';

const ExploreAvatar = () => (
  <Box
    component="img"
    src={classroomImg}
    sx={{
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      margin: 'auto',
      width: '100px',
      height: '100px;',
    }}
  />
);

export default ExploreAvatar;
